import React from 'react';

import { Box, Divider } from '@chakra-ui/react';

import { ResultRenderer } from '../../components/results/ResultRenderer';
import CompetencySummary from './CompetencySummary';

const PeopleViewCompetencyScrollableNav = ({ competencyId, ...question }) => (
  <Box
    sx={{
      width: '100%',
      '.scrollableSection': {
        background: '#F5F7F9',
      },
      borderRadius: '4px',
      overflow: 'hidden',
      padding: '0 12px 12px 12px',
    }}
  >
    <Box bg="#F5F7F9" display="flex" flexDir="column" p="16px">
      <CompetencySummary competencyId={competencyId} />
    </Box>
    <Box px="16px">
      <Divider color="#EBEFF3" opacity={1} />
    </Box>
    <Box bg="#F5F7F9" p="16px">
      <ResultRenderer {...question} />
    </Box>
  </Box>
);

export default PeopleViewCompetencyScrollableNav;
